import styled from 'styled-components';
import { Chip, FlexContainer } from '@taxdown/piccolo-web';

export const Container = styled(FlexContainer)`
  border: 1px solid ${({ theme: { colors } }) => colors.blue_5};
`;

export const ButtonsContainer = styled(FlexContainer)`
  margin-top: ${({ theme: { reference } }) => reference.dimension_32};
`;

export const ChipBanner = styled(Chip)`
  max-width: 400px;
  height: auto;
  padding: ${({ theme: { spacing } }) => spacing.spacing_08};
`;

export const Header = styled(FlexContainer)`
  width: 100%;
  background: ${({ theme: { system } }) => system.background.fds_sys_color_background_gradient_A};
  padding: ${({ theme: { reference } }) => reference.dimension_48};
  height: 176px;
  @media screen and (min-height: 500px) {
    padding: ${({ theme: { reference } }) => reference.dimension_24};
  }
`;

export const ContentContainer = styled(FlexContainer)`
  width: 425px;
  padding: ${({ theme: { reference } }) => reference.dimension_32};
`;
